import { makeStyles } from '@material-ui/core/styles'

const useStyles = makeStyles(theme => ({
  chipsWrapper: {
    [theme.breakpoints.down('sm')]: {
      width: 'auto',
      marginLeft: theme.spacing(-2),
      marginRight: theme.spacing(-2),
      paddingBottom: theme.spacing(1),
      paddingLeft: theme.spacing(2),
      overflow: 'auto',
      display: 'flex',
    },
  },
  flexNoWrap: {
    flexWrap: 'nowrap',
  },
  flexWrap: {
    flexWrap: 'wrap',
  },
}))

export default useStyles
